import { useState, useEffect } from "react";
import DatePicker from "react-multi-date-picker";
import DateObject from "react-date-object";
import persian from "react-date-object/calendars/persian";
import persian_fa from "react-date-object/locales/persian_fa";
import gregorian from "react-date-object/calendars/gregorian";

export default function ShamsiDatePicker({ value, onChange }) {
  const [date, setDate] = useState(null);

  useEffect(() => {
    if (value) {
      try {
        const persianDate = new DateObject({
          date: value,
          calendar: gregorian,
        }).convert(persian, persian_fa);
        setDate(persianDate);
      } catch (error) {
        console.error("Error converting date:", error);
      }
    } else {
      setDate(null);
    }
  }, [value]);

  const handleChange = (selectedDate) => {
    setDate(selectedDate);

    if (selectedDate) {
      // تاریخ شمسی - مستقیماً از تقویم شمسی
      const shamsi = `${selectedDate.year}/${String(selectedDate.month).padStart(2, '0')}/${String(selectedDate.day).padStart(2, '0')}`;

      // تبدیل به میلادی
      const miladiDate = new DateObject(selectedDate).convert(gregorian);
      const miladi = miladiDate.format("YYYY-MM-DD");

      onChange({ miladi, shamsi });
    } else {
      onChange({ miladi: "", shamsi: "" });
    }
  };

  return (
    <div className="w-full">
      <DatePicker
        calendar={persian}
        locale={persian_fa}
        value={date}
        onChange={handleChange}
        inputClass="w-full px-3 py-2 border rounded-md focus:outline-none"
        placeholder="تاریخ را انتخاب کنید..."
      />
    </div>
  );
}